module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/faq_hairmakeup_04-b65f62d0582807b7125babcdd1e9eb5f.png";